<div class="action-tablet-movement-order-list">

  <sc-scroll-pane>
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>
          {{'Priorität'| translate:['tmc-yard.entity.moving-order.priority', translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row">
          <sc-icon iconClass="fa-circle-exclamation" *ngIf="row.priority"></sc-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="referenceDate">
        <th mat-header-cell *matHeaderCellDef>
          {{'Referenzdatum'| translate:['tmc-yard.entity.moving-order.referenceDate',
          translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row"> {{row.referenceDate | date:'dd.MM.yy H:mm'}} </td>
      </ng-container>

      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef>
          {{'Umfang'| translate:['tmc-yard.entity.moving-order.scope', translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row">
          <app-transport-scope-icon [scope]="row.scope"></app-transport-scope-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef>
          {{'Transportmerkmal'| translate:['tmc-yard.entity.moving-order.identifier',
          translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row"> {{row.identifier}} </td>
      </ng-container>

      <ng-container matColumnDef="transportReference">
        <th mat-header-cell *matHeaderCellDef>
          {{'Referenz'| translate:['tmc-yard.entity.moving-order.transportReference',
          translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row"> {{row.transportReference}} </td>
      </ng-container>

      <ng-container matColumnDef="currentStation">
        <th mat-header-cell *matHeaderCellDef>
          {{'akt. Station'| translate:['tmc-yard.entity.moving-order.currentStation',
          translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row"> {{row.currentStation}} </td>
      </ng-container>

      <ng-container matColumnDef="targetStation">
        <th mat-header-cell *matHeaderCellDef>
          {{'Zielstation'| translate:['tmc-yard.entity.moving-order.targetStation',
          translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row"> {{row.targetStation}} </td>
      </ng-container>

      <ng-container matColumnDef="processingStatus">
        <th mat-header-cell *matHeaderCellDef>
          {{'Bearbeitungsstatus'| translate:['tmc-yard.entity.moving-order.processingStatus.label',
          translationService.language]}}
        </th>
        <td mat-cell *matCellDef="let row"> {{row.processingStatus |
          translate:['tmc-yard.entity.moving-order.processingStatus.' + row.processingStatus,
          translationService.language]}}
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: false"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay" ></tr>

    </table>
  </sc-scroll-pane>

</div>
